import type { PanelItem } from '@vedalib/editor/lib/elements'
import { createItem } from '@vedalib/editor/lib/elements/elements/Tabs/constants'

import { genElementValueField } from 'components/Editor/Toolbar/NodeForm/genElementValueField'
import Padding from 'components/Editor/Toolbar/Padding'
import { FieldArray, FormField } from 'components/formKit'
import { chainName } from 'utils/form'

import { useThroughElementItemsArrayEffect } from '../../utils/formEffects'
import TabsFormValueItem from './TabsFormValueItem'
import type { TabsFormValueType } from './tabsTypes'

const TABS_FIELD = genElementValueField({
  name: 'items',
  as: FieldArray<PanelItem>,
  props: {
    min: 1,
    RenderItem: TabsFormValueItem,
    defaultItem: createItem(),
  },
  useConfigs: [useThroughElementItemsArrayEffect],
})

const TabsForm: TabsFormValueType = ({ name }) => {
  return (
    <Padding bottom gap sides>
      <FormField config={chainName(name, TABS_FIELD)} />
    </Padding>
  )
}

export default TabsForm
